// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-1d9ba1c9]{display:none}.carousel-story-card[data-v-1d9ba1c9]{max-width:437.3333333333px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
